import {AxiosResponse} from 'axios'
import {RawClientUser} from '../types'
import {HttpInstance} from '../createHttpInstance'

interface Params {
  accessToken: string
  origin: 'system' | 'campanion'
  clientID: number
}

export interface RawExchangeResponse {
  Status: 'Failure' | 'Success'
  ClientUsers: RawClientUser[]
}
export interface Exchange<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const exchange: Exchange<Params, RawExchangeResponse> = (
  http,
  {accessToken, origin, clientID},
) => {
  // Create request config with Authorization header
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }

  // Remove accessToken from body, keep other params
  return http.post(
    '/v1/auth/exchange',
    {
      Origin: origin,
      ClientID: clientID,
    },
    config,
  )
}
